export class MessageDetailComponent {
    /*@ngInject*/
    constructor($http, userService, $scope, $stateParams, $state, fetch, $timeout, lookup) {
        console.log('running init')
      this.$http = $http;
      this.userService = userService;
      this.$scope = $scope;
      this.$stateParams = $stateParams;
      this.$state = $state;
      this.message = $stateParams.messageData;
      this.loading = false;
      this.error = null;
      this.currentUser = null;
      this.fetch = fetch;
      this.$timeout = $timeout;
      this.replyMessage = '';
      this.messageSent = false;
      this.messageSentDialogPendingNavigation = false;
      this.shouldNavigateAfterDialog = false;
      this.lookup = lookup;
      this.jurisdiction = null; // line below was returning a blank in some cases, we'll set this later now
      this.$scope.currentJurisdiction = this.lookup.getJurisdiction();



      console.log('running init')
    }

    $onInit() {
        console.log("state params", this.$stateParams);

        if(this.$stateParams.data){
          this.$scope.chainData = this.$stateParams.data;
          if(this.$scope.chainData.message_chain_id){
            this.$scope.message_chain_id = this.$scope.chainData.message_chain_id;
          }
          if(this.$scope.chainData.submission_id){
            this.$scope.submission_id = this.$scope.chainData.submission_id;
          }
        }

        this.previousState = this.$stateParams.messageData || 'messages'; // default to messages if not specified
        console.log(this.previousState);
        this.loading = true;
        this.userService.getCurrentUser()
          .then(response => {
            this.currentUser = response.data;
            this.userService.setCurrentUser(response.data);

            // Check if we have a submission_id and load messages
           // Check for either submissionId or message_chain_id
        if (this.$stateParams.submissionId) {
          return this.loadMessages(this.$stateParams.submissionId, 'submission');
      } else if (this.$stateParams.message_chain_id) {
          return this.loadMessages(this.$stateParams.message_chain_id, 'chain');
      } else {
          this.error = 'No submission ID or message chain ID provided';
          this.loading = false;
      }
          })
          .catch(err => {
            console.error('Error fetching current user:', err);
            this.error = 'Failed to load user data';
            this.loading = false;
          });

      }


loadMessages(id, type) {
    console.log(`Loading messages for ${type}:`, id);
    this.loading = true;

    const endpoint = type === 'submission'
        ? `api/messages/submission/${id}`
        : `api/messages/chain/${id}`;

    console.log("Endpoint:", endpoint)
    return this.fetch.getAllItems(endpoint)
      .then(response => {
        console.log('Messages received:', response.data);
        this.$timeout(() => {
         if(type === 'submission'){
          this.message = response.data[0];
          if(this.message && this.message.messages){
              this.messages = this.message.messages;
              this.jurisdiction = this.message.jurisdiction; // related messages in the detail page will always be associated with 1 jurisdiction so we can set it here
          }
         } else {
          this.messages = response.data;
          console.log(this.messages);
         }
          this.error = null;
          this.loading = false;
        });
      })
      .catch(err => {
        console.error('Error loading messages:', err);
        this.$timeout(() => {
          this.error = 'Failed to load messages';
          this.loading = false;
        });
      });
}

    fetchMessageDetails() {
      if (!this.$stateParams.submissionId) {
        this.error = 'No message ID provided';
        return;
      }

      this.loading = true;
      return this.$http.get(`api/messages/submission/${this.$stateParams.submissionId}`)
        .then(response => {
          this.message = response.data;
          this.error = null;
        })
        .catch(err => {
          console.error('Error fetching message details:', err);
          this.error = 'Failed to load message details';
        })
        .finally(() => {
          this.loading = false;
          if (!this.$scope.$$phase) {
            // this.$scope.$apply();
          }
        });
    }

    goBack() {
      this.$state.go('messages');
    }

    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    submitReply($event) {

      if ($event) {
          $event.preventDefault();
        }

        if (!this.replyMessage) {
          return;
        }

        const now = new Date();
        const reply = {
          from: this.currentUser.id,
          comment: this.replyMessage.trim(),
          created_at: now.toISOString(),
          to_jurisdiction: this.jurisdiction, // was getting set to null when using the currentJurisdication
          submission_id: this.$scope.submission_id
        };



        if(this.$scope.chainData.message_chain_id){
          reply.message_chain_id = this.$scope.chainData.message_chain_id;
        }

        if(this.$scope.chainData.message_type){
          reply.message_type = this.$scope.chainData.message_type;
        }

        console.log(reply);




        this.fetch.updateItem('api/messages', reply)
          .then(response => {
            console.log('Reply sent:', response.data);
            this.$timeout(() => {
              this.replyMessage = null;
              this.messageSent = true;
              this.shouldNavigateAfterDialog = true;
            });
          })
          .catch(err => {
            console.error('Error sending reply:', err);
            this.$timeout(() => {
              this.error = 'Failed to send reply';
            });
          });
    }

  closeModal() {
    this.messageSent = false;
    if (this.shouldNavigateAfterDialog) {
      this.shouldNavigateAfterDialog = false;
      this.$state.go(this.previousState);
    }
  }

  handleMessageSentDialogClose() {
    this.closeModal();
  }

    groupMessagesByDate(messages) {
        if (!messages) return {};

        return messages.reduce((groups, message) => {
          const date = new Date(message.date).toLocaleDateString();
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(message);
          return groups;
        }, {});
      }

      markAsRead(message) {
        console.log(message);
        if (message.status === 'read') return;

        return this.fetch.putItem(`api/messages/${message.notify_id}/read`, {
          status: 'read'
        })
          .then(() => {
            message.status = 'read';
          })
          .catch(err => {
            console.error('Error marking message as read:', err);
            this.error = 'Failed to mark message as read';
          });
      }

        handleMarkAsRead(msg) {
            msg.read_at = new Date();
            // this.$scope.$apply(); // Force digest cycle update

            this.markAsRead(msg).catch(() => {
                msg.read_at = null;
                this.$scope.$apply(); // Revert UI if API fails
            });
}
  }

  export default angular.module('appApp.messageDetail', [])
    .component('messageDetail', {
      template: require('./message-detail.html'),
      controller: MessageDetailComponent
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/account/messages/message-detail.component.js